import React, { useEffect } from 'react'
import { moduleContext } from 'react-contextual'
import { useDispatch, useSelector } from 'react-redux'
import { reconApiEvents, reconApiSelectors } from '../../../../../../modules/api/recon'
interface RecentActivityProviderProps {
  customerId: string
  accountId: string
}

const RecentActivityProvider = moduleContext()(
  ({
    context,
    children,
    customerId,
    accountId,
  }: RecentActivityProviderProps & { context: any; children: React.ReactNode }) => {
    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(reconApiEvents.customerAccountActivity_request({ customerId, accountId }))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, accountId])

    const store = {
      accountId,
      recentActivity: useSelector(state => reconApiSelectors.getCustomerRecentActivity(state)(customerId, accountId)),
    }

    return <context.Provider value={store}>{children}</context.Provider>
  },
)

export default RecentActivityProvider
